/**
 * Test IDs for QA automation.
 */
export const testIds = {
  trailerTypeSelect: "trailer-type-select",
  trailerTypeOption: "trailer-type-select-option",
} as const;
